// store/action/ActionTypes.js

export const userActionTypes = {
  LOGIN_START: 'LOGIN_START',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGOUT: 'LOGOUT',
  SET_QB_CONNECTED: 'SET_QB_CONNECTED',
  
  // ADD THESE IF MISSING:
  LOGIN_GUEST: 'LOGIN_GUEST',
  LOGIN_GUEST_SUCCESS: 'LOGIN_GUEST_SUCCESS',
  LOGIN_GUEST_ERROR: 'LOGIN_GUEST_ERROR',
};